import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

// 先渲染应用，IAM 初始化及登录在用户确认项目 S 码后再执行
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('ROOT')
)
